exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tripHistory {\n  width: calc(100% - (55px));\n  height: calc(100% - (50px));\n  position: absolute !important;\n  background: #ddd;\n  margin: 0;\n  top: 50px;\n  right: 0;\n  z-index: 500;\n  box-shadow: rgba(9, 30, 66, 0.55) 0px 15px 20px -2px; }\n", ""]);

// exports
